import { getCookie, delCookie, setCookie } from '../plugins/cookie'
import { reactive } from 'vue'
import { ElMessage } from "element-plus"
const store = {
    debug: true,
    state: reactive({
      userInfo: null,
      isLogin: false, // 是否登录
      has_review_hide:0,//屏蔽叶子节点数量(座舱)
      has_intelligent_hide:0,//屏蔽叶子节点数量(驾驶)
      download_content:0,// 下载权限 1座舱 2驾驶 3都有 0都没有
      //加入pk id
      compareCarData: localStorage.getItem(getCookie('loginToken')+'compareCar') ? JSON.parse(localStorage.getItem(getCookie('loginToken')+'compareCar')) : null,
      compareCarDataOta: localStorage.getItem(getCookie('loginToken')+'compareCarOta_v271') ? JSON.parse(localStorage.getItem(getCookie('loginToken')+'compareCarOta_v271')) : null,
      compareBrandDataOta: localStorage.getItem(getCookie('loginToken')+'compareBrandOta_v271') ? JSON.parse(localStorage.getItem(getCookie('loginToken')+'compareBrandOta_v271')) : null,
      //测评对比首页 pk
      compareCarData2: localStorage.getItem(getCookie('loginToken')+'compareCar2') ? JSON.parse(localStorage.getItem(getCookie('loginToken')+'compareCar2')) : null,
      //v4 pk
      compareCarDataV2: localStorage.getItem(getCookie('loginToken')+'compareCarV2') ? JSON.parse(localStorage.getItem(getCookie('loginToken')+'compareCarV2')) : null,
      // 智能驾驶
      compareCarData_drive: localStorage.getItem(getCookie('loginToken')+'compareCar_drive') ? JSON.parse(localStorage.getItem(getCookie('loginToken')+'compareCar_drive')) : null,
      //测评对比首页 pk
      compareCarData2_drive: localStorage.getItem(getCookie('loginToken')+'compareCar2_drive') ? JSON.parse(localStorage.getItem(getCookie('loginToken')+'compareCar2_drive')) : null,
      
      downloadList:[],//下载列表
      addDownList:[],
    }),
    getFilenameFromUrl(url) {
      const parts = url.split('.');
      return parts[parts.length - 1];
    },
    addDownload(url_list,model_name,node_name) {
      const that = this;
      that.state.addDownList = url_list.map((item,ind)=>{
        return {
          id:item.attach_id,
          name:model_name+'-'+node_name+'-'+ind+'.'+that.getFilenameFromUrl(item.attach_value),
          url:item.attach_value.replace('http://','https://'),
          progress:0,
          xhr:null,
        }
      })
    },
    signOut(){
        if(process.env.NODE_ENV=='production'){
          const domain = process.env.VUE_APP_DOMAIN ? process.env.VUE_APP_DOMAIN.replace('//', '').replace('/', '') : 'ceping.cheyun.com'
          delCookie("avatar", domain)
          delCookie("loginToken", domain)
          delCookie("nickName", domain)
          delCookie("username", domain)
          delCookie("mobile", domain)
          delCookie("failure_date", domain)
          delCookie("role_id", domain)
        }else{
          delCookie("avatar", "localhost")
          delCookie("loginToken","localhost")
          delCookie("nickName", "localhost")
          delCookie("username", "localhost")
          delCookie("mobile", "localhost")
          delCookie("failure_date", "localhost")
          delCookie("role_id", "localhost")
        }
        this.state.userInfo = null;
        this.state.isLogin = false;
    },
    signIn(userInfo,type){
      console.log('signIn', userInfo)

      if(process.env.NODE_ENV=='production'){
        const domain = process.env.VUE_APP_DOMAIN ? process.env.VUE_APP_DOMAIN.replace('//', '').replace('/', '') : 'ceping.cheyun.com'
        setCookie("avatar", userInfo.avatar, domain, 3*365*24*60*60)
        setCookie("loginToken", userInfo.loginToken, domain, 3*365*24*60*60)
        setCookie("nickName", userInfo.nickName, domain, 3*365*24*60*60)
        setCookie("username", userInfo.username, domain, 3*365*24*60*60)
        setCookie("mobile", userInfo.mobile, domain, 3*365*24*60*60)
        setCookie("failure_date", userInfo.failure_date, domain, 3*365*24*60*60)
        setCookie("role_id", userInfo.role_id, domain, 3*365*24*60*60)
        setCookie("sign_methods",type || 1, domain, 3*365*24*60*60)
      }else{
        setCookie("avatar", userInfo.avatar, "localhost", 999*24*60*60)
        setCookie("loginToken", userInfo.loginToken, "localhost", 999*24*60*60)
        setCookie("nickName", userInfo.nickName, "localhost", 999*24*60*60)
        setCookie("username", userInfo.username, "localhost", 999*24*60*60)
        setCookie("mobile", userInfo.mobile, "localhost", 999*24*60*60)
        setCookie("failure_date", userInfo.failure_date, "localhost", 999*24*60*60)
        setCookie("role_id", userInfo.role_id, "localhost", 999*24*60*60)
        setCookie("sign_methods",type || 1, "localhost", 999*24*60*60)
      }
      this.state.userInfo=userInfo;
        this.state.isLogin = true
    },
    updateCookie(key, value) {
      if(process.env.NODE_ENV=='production'){
        const domain = process.env.VUE_APP_DOMAIN ? process.env.VUE_APP_DOMAIN.replace('//', '').replace('/', '') : 'ceping.cheyun.com'
        setCookie(key, value, domain, 3*365*24*60*60)
      }else{
        setCookie(key, value, "localhost", 3*365*24*60*60)
      }
    },
    updateUsername(username){
      this.state.userInfo={
        ...this.state.userInfo,
        username,
      }
    },
    checkLogin(){
      console.log('checkLogin')
      let userInfo = null
      const loginToken =  getCookie('loginToken')
      if(loginToken){
        userInfo = {
          loginToken,
          avatar: getCookie('avatar'),
          nickName: getCookie('nickName'),
          username: getCookie('username'),
          mobile: getCookie('mobile'),
          failure_date: getCookie('failure_date'),
          role_id: getCookie('role_id'),
          role: 1,
          permission: '1,2,3,4'
        }
        // 更新存储的数据，刷新时间
        this.signIn(userInfo, getCookie('sign_methods'))
      }
      this.state.userInfo=userInfo;
      return userInfo
    },
    checkLeafHide(type,num){
      if(type =='zc'){this.state.has_review_hide = num}
      if(type =='js'){this.state.has_intelligent_hide = num}
    },
    getCompareCarData(){
      const compareCarData = localStorage.getItem(getCookie('loginToken')+'compareCar')
      this.state.compareCarData = compareCarData ? JSON.parse(compareCarData) : ''
      return this.state.compareCarData
    },
    setCompareCarData(car){
      let data = this.state.compareCarData || this.getCompareCarData()
      data = data || []
      for(let item of data){
        if(item.model_id == car.model_id){
          ElMessage.error('该车型已加入对比!')
          return
        }
      }
      if(data.length>=3){
        ElMessage.error('只能对比3款车型!')
        return
      }
      data.push(car)
      localStorage.setItem(getCookie('loginToken')+'compareCar', JSON.stringify(data))
      this.state.compareCarData = data
      ElMessage.success('加入成功!')
    },
    deleteCompareCarData(model_id){
      let data = this.state.compareCarData || this.getCompareCarData()
      data = data || []
      for(let [index, item] of data.entries()){
        if(item.model_id == model_id){
          data.splice(index, 1)
          localStorage.setItem(getCookie('loginToken')+'compareCar', JSON.stringify(data))
          ElMessage.success('已删除改对比车型!')
          break;
        }
      }
    },


    getCompareCarDataOta(){
      const compareCarData = localStorage.getItem(getCookie('loginToken')+'compareCarOta_v271')
      this.state.compareCarDataOta = compareCarData ? JSON.parse(compareCarData) : ''
      return this.state.compareCarDataOta
    },
    setCompareCarDataOta(car){
      console.log('car', car)
      let data = this.state.compareCarDataOta || this.getCompareCarDataOta()
      data = data || []
      for(let item of data){
        if(item.id == car.id){
          ElMessage.error('该车型已加入对比!')
          return
        }
      }
      if(data.length>=3){
        ElMessage.error('只能对比3款车型!')
        return
      }
      data.push(car)
      localStorage.setItem(getCookie('loginToken')+'compareCarOta_v271', JSON.stringify(data))
      this.state.compareCarDataOta = data
      ElMessage.success('加入成功!')
    },
    deleteCompareCarDataOta(id){
      let data = this.state.compareCarDataOta || this.getCompareCarDataOta()
      data = data || []
      for(let [index, item] of data.entries()){
        if(item.id == id){
          data.splice(index, 1)
          localStorage.setItem(getCookie('loginToken')+'compareCarOta_v271', JSON.stringify(data))
          ElMessage.success('已删除改对比车型!')
          break;
        }
      }
    },


    getCompareBrandDataOta(){
      const compareBrandData = localStorage.getItem(getCookie('loginToken')+'compareBrandOta_v271')
      this.state.compareBrandDataOta = compareBrandData ? JSON.parse(compareBrandData) : ''
      return this.state.compareBrandDataOta
    },
    setCompareBrandDataOta(brand){
      console.log('brand', brand)
      let data = this.state.compareBrandDataOta || this.getCompareBrandDataOta()
      data = data || []
      for(let item of data){
        if(item.id == brand.id){
          ElMessage.error('该品牌已加入对比!')
          return
        }
      }
      if(data.length>=3){
        ElMessage.error('只能对比3个品牌!')
        return
      }
      data.push(brand)
      localStorage.setItem(getCookie('loginToken')+'compareBrandOta_v271', JSON.stringify(data))
      this.state.compareBrandDataOta = data
      ElMessage.success('加入成功!')
    },
    deleteCompareBrandDataOta(id){
      let data = this.state.compareBrandDataOta || this.getCompareBrandDataOta()
      data = data || []
      for(let [index, item] of data.entries()){
        if(item.id == id){
          data.splice(index, 1)
          localStorage.setItem(getCookie('loginToken')+'compareBrandOta_v271', JSON.stringify(data))
          ElMessage.success('已删除改对比品牌!')
          break;
        }
      }
    },

    


    clearCompareCarData2(){
      let data = [];
      localStorage.setItem(getCookie('loginToken')+'compareCar2', JSON.stringify(data));
    },
    getCompareCarData2(){
      const compareCarData2 = localStorage.getItem(getCookie('loginToken')+'compareCar2')
      this.state.compareCarData2 = compareCarData2 ? JSON.parse(compareCarData2) : ''
      return this.state.compareCarData2
    },
    setCompareCarData2(car){
      let data = this.state.compareCarData2 || this.getCompareCarData2()
      data = data || []
      for(let item of data){
        if(item.model_id == car.model_id){
          ElMessage.error('该车型已加入对比!')
          return
        }
      }
      if(data.length>=3){
        ElMessage.error('只能对比3款车型!')
        return
      }
      data.push(car)
      console.log('car', car);
      console.log('data', data);
      localStorage.setItem(getCookie('loginToken')+'compareCar2', JSON.stringify(data))
      this.state.compareCarData2 = data

      console.log('set --- compareCarData2', this.getCompareCarData2());
      ElMessage.success('加入成功!')
    },
    updateCompareCarData2(old_id,new_car){
      let data = this.state.compareCarData2 || this.getCompareCarData2();
      data = data || []
      for(let [index, item] of data.entries()){
        if(item.model_id == old_id){
          data.splice(index, 1,new_car)
          localStorage.setItem(getCookie('loginToken')+'compareCar2', JSON.stringify(data))
          ElMessage.success('已更换改对比车型!')
          this.state.compareCarData2 = JSON.parse(localStorage.getItem(getCookie('loginToken')+'compareCar2'));
          break;
        }
      }
    },
    deleteCompareCarData2(model_id){
      let data = this.state.compareCarData2 || this.getCompareCarData2()
      data = data || []
      for(let [index, item] of data.entries()){
        if(item.model_id == model_id){
          data.splice(index, 1)
          localStorage.setItem(getCookie('loginToken')+'compareCar2', JSON.stringify(data))
          ElMessage.success('已删除改对比车型!')
          this.state.compareCarData2 = JSON.parse(localStorage.getItem(getCookie('loginToken')+'compareCar2'));
          break;
        }
      }
    },

    clearCompareCarDataV2(){
      let data = [];
      localStorage.setItem(getCookie('loginToken')+'compareCarV2', JSON.stringify(data));
    },
    getCompareCarDataV2(){
      const compareCarDataV2 = localStorage.getItem(getCookie('loginToken')+'compareCarV2')
      this.state.compareCarDataV2 = compareCarDataV2 ? JSON.parse(compareCarDataV2) : ''
      return this.state.compareCarDataV2
    },
    setCompareCarDataV2(car){
      let data = this.state.compareCarDataV2 || this.getCompareCarDataV2()
      data = data || []
      for(let item of data){
        if(item.model_id == car.model_id){
          ElMessage.error('该车型已加入对比!')
          return
        }
      }
      if(data.length>=3){
        ElMessage.error('只能对比3款车型!')
        return
      }
      data.push(car)
      localStorage.setItem(getCookie('loginToken')+'compareCarV2', JSON.stringify(data))
      this.state.compareCarDataV2 = data
      ElMessage.success('加入成功!')
    },
    updateCompareCarDataV2(old_id,new_car){
      let data = this.state.compareCarDataV2 || this.getCompareCarDataV2();
      data = data || []
      for(let [index, item] of data.entries()){
        if(item.model_id == old_id){
          data.splice(index, 1,new_car)
          localStorage.setItem(getCookie('loginToken')+'compareCarV2', JSON.stringify(data))
          ElMessage.success('已更换改对比车型!')
          this.state.compareCarDataV2 = JSON.parse(localStorage.getItem(getCookie('loginToken')+'compareCarV2'));
          break;
        }
      }
    },
    deleteCompareCarDataV2(model_id){
      let data = this.state.compareCarDataV2 || this.getCompareCarDataV2()
      data = data || []
      for(let [index, item] of data.entries()){
        if(item.model_id == model_id){
          data.splice(index, 1)
          localStorage.setItem(getCookie('loginToken')+'compareCarV2', JSON.stringify(data))
          ElMessage.success('已删除改对比车型!')
          this.state.compareCarDataV2 = JSON.parse(localStorage.getItem(getCookie('loginToken')+'compareCarV2'));
          break;
        }
      }
    },

    // 智能驾驶
    getCompareCarData_drive(){
      const compareCarData_drive = localStorage.getItem(getCookie('loginToken')+'compareCar_drive')
      this.state.compareCarData_drive = compareCarData_drive ? JSON.parse(compareCarData_drive) : ''
      return this.state.compareCarData_drive
    },
    setCompareCarData_drive(car){
      let data = this.state.compareCarData_drive || this.getCompareCarData_drive()
      data = data || []
      for(let item of data){
        if(item.model_id == car.model_id){
          ElMessage.error('该车型已加入对比!')
          return
        }
      }
      if(data.length>=3){
        ElMessage.error('只能对比3款车型!')
        return
      }
      data.push(car)
      localStorage.setItem(getCookie('loginToken')+'compareCar_drive', JSON.stringify(data))
      this.state.compareCarData_drive = data
      ElMessage.success('加入成功!')
    },
    deleteCompareCarData_drive(model_id){
      let data = this.state.compareCarData_drive || this.getCompareCarData_drive()
      data = data || []
      for(let [index, item] of data.entries()){
        if(item.model_id == model_id){
          data.splice(index, 1)
          localStorage.setItem(getCookie('loginToken')+'compareCar_drive', JSON.stringify(data))
          ElMessage.success('已删除改对比车型!')
          break;
        }
      }
    },
    clearCompareCarData2_drive(){
      let data = [];
      localStorage.setItem(getCookie('loginToken')+'compareCar2_drive', JSON.stringify(data));

    },
    getCompareCarData2_drive(){
      const compareCarData2_drive = localStorage.getItem(getCookie('loginToken')+'compareCar2_drive')
      this.state.compareCarData2_drive = compareCarData2_drive ? JSON.parse(compareCarData2_drive) : ''
      return this.state.compareCarData2_drive
    },
    setCompareCarData2_drive(car){
      let data = this.state.compareCarData2_drive || this.getCompareCarData2_drive()
      data = data || []
      for(let item of data){
        if(item.model_id == car.model_id){
          ElMessage.error('该车型已加入对比!')
          return
        }
      }
      if(data.length>=3){
        ElMessage.error('只能对比3款车型!')
        return
      }
      data.push(car)
      localStorage.setItem(getCookie('loginToken')+'compareCar2_drive', JSON.stringify(data))
      this.state.compareCarData2_drive = data
      ElMessage.success('加入成功!')
    },
    updateCompareCarData2_drive(old_id,new_car){
      let data = this.state.compareCarData2_drive || this.getCompareCarData2_drive();
      data = data || []
      for(let [index, item] of data.entries()){
        if(item.model_id == old_id){
          data.splice(index, 1,new_car)
          localStorage.setItem(getCookie('loginToken')+'compareCar2_drive', JSON.stringify(data))
          ElMessage.success('已更换改对比车型!')
          this.state.compareCarData2_drive = JSON.parse(localStorage.getItem(getCookie('loginToken')+'compareCar2_drive'));
          break;
        }
      }
    },
    deleteCompareCarData2_drive(model_id){
      let data = this.state.compareCarData2_drive || this.getCompareCarData2_drive()
      data = data || []
      for(let [index, item] of data.entries()){
        if(item.model_id == model_id){
          data.splice(index, 1)
          localStorage.setItem(getCookie('loginToken')+'compareCar2_drive', JSON.stringify(data))
          ElMessage.success('已删除改对比车型!')
          this.state.compareCarData2_drive = JSON.parse(localStorage.getItem(getCookie('loginToken')+'compareCar2_drive'));
          break;
        }
      }
    },


    clearCompareCarDataV2_drive(){
      let data = [];
      localStorage.setItem(getCookie('loginToken')+'compareCarV2_drive', JSON.stringify(data));

    },
    getCompareCarDataV2_drive(){
      const compareCarDataV2_drive = localStorage.getItem(getCookie('loginToken')+'compareCarV2_drive')
      this.state.compareCarDataV2_drive = compareCarDataV2_drive ? JSON.parse(compareCarDataV2_drive) : ''
      return this.state.compareCarDataV2_drive
    },
    setCompareCarDataV2_drive(car){
      let data = this.state.compareCarDataV2_drive || this.getCompareCarDataV2_drive()
      data = data || []
      for(let item of data){
        if(item.model_id == car.model_id){
          ElMessage.error('该车型已加入对比!')
          return
        }
      }
      if(data.length>=3){
        ElMessage.error('只能对比3款车型!')
        return
      }
      data.push(car)
      localStorage.setItem(getCookie('loginToken')+'compareCarV2_drive', JSON.stringify(data))
      this.state.compareCarDataV2_drive = data
      ElMessage.success('加入成功!')
    },
    updateCompareCarDataV2_drive(old_id,new_car){
      let data = this.state.compareCarDataV2_drive || this.getCompareCarDataV2_drive();
      data = data || []
      for(let [index, item] of data.entries()){
        if(item.model_id == old_id){
          data.splice(index, 1,new_car)
          localStorage.setItem(getCookie('loginToken')+'compareCarV2_drive', JSON.stringify(data))
          ElMessage.success('已更换改对比车型!')
          this.state.compareCarDataV2_drive = JSON.parse(localStorage.getItem(getCookie('loginToken')+'compareCarV2_drive'));
          break;
        }
      }
    },
    deleteCompareCarDataV2_drive(model_id){
      let data = this.state.compareCarDataV2_drive || this.getCompareCarDataV2_drive()
      data = data || []
      for(let [index, item] of data.entries()){
        if(item.model_id == model_id){
          data.splice(index, 1)
          localStorage.setItem(getCookie('loginToken')+'compareCarV2_drive', JSON.stringify(data))
          ElMessage.success('已删除改对比车型!')
          this.state.compareCarDataV2_drive = JSON.parse(localStorage.getItem(getCookie('loginToken')+'compareCarV2_drive'));
          break;
        }
      }
    },



    //权限判断
    getDownloadAuth(route){ //route 驾驶会传这个参数 座舱无参数 后面权限有变了可以根据这个调整逻辑
      console.log(route);
      let auth = false;
      auth = this.state.download_content == 1 ? true : false;
      return auth;
    }
}
export default store

